<template>
  <div>
    <div v-if="error" class="alert alert-danger" role="alert">
      {{ error.message }}
    </div>
    <ResourceLinks ref="resources" :resources="resources" :drawers="drawers" :isVersion="isVersion"></ResourceLinks>
    <component :is="currentLayout" ref="layout" :error="error" :pageId="page.id" :source="content"></component>
  </div>
</template>

<script>
import layouts from './layouts'
import ResourceLinks from './ResourceLinks.vue'


export default {
  props: ['page', 'error'],
  components: {
    ...layouts,
    ResourceLinks
  },
  data() {
    return {
      content: _.cloneDeep(this.page.content) || {},
      resources: _.cloneDeep(this.page.resources) || [],
      drawers: _.cloneDeep(this.page.drawers) || []
    }
  },
  computed: {
    currentLayout() {
      console.log(this.page.layout)
      switch (this.page.layout) {
        case 'SixtyForty':
        case 'FortySixty':
          return 'Standard'
        default:
          return this.page.layout
      }
    },
    isVersion() {
      return !!this.page.parent_page_id
    }
  },
  methods: {
    getValue() {
      return this.$refs.layout.getValue()
    },
    getResources() {
      return this.$refs.resources.getResources()
    },
    getDrawers() {
      return this.$refs.resources.getDrawers()
    }
  }
}
</script>
